import "core-js/modules/es.reflect.construct.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import { loadJS } from "../utils/WaitJsLoaded";
import BaseAdapter from "./BaseAdapter";
import { urlFormatter, isHTTPUrl, isZZ, isAndroid, isZZUrl, isZZSellerUrl, isCheckUrl, getDomain, getDomainFromURL, domainReplacement, getUrlParams, getUrlParamsWithoutDecode, addQuery } from "../utils/utils";
import { setCookieOrigin } from "../utils/cookies";
import { beforeLogin } from "./Login";
var API_DOMAIN = /58\.com/.test(location.href) ? "zhuan.58.com" : "app.zhuanzhuan.com";

var counter = function () {
  var c = 0;
  return function () {
    return c++;
  };
}();

var MAdapter = (_class = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(MAdapter, _BaseAdapter);

  var _super = _createSuper(MAdapter);

  function MAdapter() {
    var _this;

    _classCallCheck(this, MAdapter);

    for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(props));
    _this.urlDomainWhiteList = [".58.com", ".zhuanzhuan.com", ".zhuanstatic.com"];
    _this.loadWhiteListSuccess = null;
    _this.loadWhiteListFail = null;
    _this.hasLoadedWhiteList = new Promise(function (resolve, reject) {
      _this.loadWhiteListSuccess = resolve;
      _this.loadWhiteListFail = reject;
    }); // 请求白名单，延迟300ms，避免影响业务性能

    setTimeout(function () {
      _this.fetchUrlDomainWhiteList();
    }, 300);
    return _this;
  }

  _createClass(MAdapter, [{
    key: "fetchUrlDomainWhiteList",
    value: function fetchUrlDomainWhiteList() {
      var self = this;
      var cbName = "fetchUrlDomainWhiteList".concat(counter());

      window[cbName] = function (data) {
        var _ref = data.respData || {},
            urlDomainWhiteList = _ref.urlDomainWhiteList;

        if (urlDomainWhiteList instanceof Array) {
          self.urlDomainWhiteList = urlDomainWhiteList;
          self.loadWhiteListSuccess();
        } else {
          self.loadWhiteListFail();
        }
      };

      loadJS("https://".concat(API_DOMAIN, "/zz/transfer/getmhostlist?callback=").concat(cbName), function () {
        return window[cbName] = void 0;
      });
    }
  }, {
    key: "setTitle",
    value: function setTitle(obj) {
      var title = obj.title;
      document.title = title;
    }
  }, {
    key: "skipToUrl",
    value: function () {
      var _skipToUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(obj) {
        var _this2 = this;

        var targetUrl, needClose, _obj$extra, extra, canSkip, urlObj, searchParams, searchDomain, searchObj, passTimes, redirectMode, isZZAndroid;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                targetUrl = obj.targetUrl, needClose = obj.needClose, _obj$extra = obj.extra, extra = _obj$extra === void 0 ? {} : _obj$extra;
                targetUrl = domainReplacement(targetUrl);
                targetUrl = addQuery(targetUrl, extra);

                if (!(isZZUrl(targetUrl) || isZZSellerUrl(targetUrl) || isCheckUrl(targetUrl))) {
                  _context.next = 6;
                  break;
                }

                this.enterUnifiedUrl({
                  unifiedUrl: targetUrl
                });
                return _context.abrupt("return");

              case 6:
                _context.next = 8;
                return this.hasLoadedWhiteList;

              case 8:
                // 判断域名是否在白名单之内
                canSkip = false;
                urlObj = {};

                try {
                  urlObj = new URL(targetUrl);
                } catch (error) {
                  urlObj.host = getDomainFromURL(targetUrl);
                }

                searchParams = urlObj.search || "";

                while (searchParams !== decodeURIComponent(searchParams)) {
                  searchParams = decodeURIComponent(searchParams);
                }

                searchDomain = [];
                searchObj = {};
                searchParams.split("?").forEach(function (item) {
                  if (item) {
                    // ??是为了兼容getUrlParams方法
                    searchObj = Object.assign({}, searchObj, getUrlParams("??" + item));
                  }
                });
                Object.keys(searchObj).forEach(function (key) {
                  var host = "";

                  try {
                    host = new URL(searchObj[key]).host;
                  } catch (error) {
                    host = "";
                  }

                  host && searchDomain.push(host);
                });
                searchDomain.push(urlObj.host);
                passTimes = 0;
                searchDomain.forEach(function (domain) {
                  try {
                    _this2.urlDomainWhiteList.forEach(function (whiteDomain) {
                      if (domain.indexOf(whiteDomain) > -1) {
                        passTimes += 1;
                        throw new Error(); //结束整体循环
                      }
                    });
                  } catch (error) {}
                });

                if (passTimes === searchDomain.length) {
                  canSkip = true;
                }

                redirectMode = window.location.href.indexOf("/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/") > -1 ? top.location : window.location;

                if (canSkip) {
                  // 需要关闭当前则用replace
                  if (needClose == 1) {
                    isZZAndroid = isZZ && isAndroid();
                    redirectMode.replace(urlFormatter(targetUrl, isZZAndroid));
                  } else {
                    redirectMode.href = urlFormatter(targetUrl);
                  }
                } else {
                  alert("跳转网址中含有不安全的域名，访问该网址可能会给您造成财产损失或隐私泄露，本次跳转失败\n\n目标网址：" + targetUrl);
                  console.log("跳转失败，当前域名不在白名单中");
                }

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function skipToUrl(_x) {
        return _skipToUrl.apply(this, arguments);
      }

      return skipToUrl;
    }()
  }, {
    key: "login",
    value: function login(callback) {
      var targetUrl, isCheck, isZlj, needReplaceLocation, headTip;

      if (_typeof(callback) == "object") {
        targetUrl = callback.targetUrl;
        isCheck = callback.isCheck;
        isZlj = callback.isZlj;
        headTip = callback.headTip;
        needReplaceLocation = callback.needReplaceLocation;
        callback = callback.callback;
      }

      targetUrl = targetUrl || location.href;
      var domain = getDomain(targetUrl);
      var checkURL = "".concat(domain, "/g/g-loginsms/index.html?callbackUrl=").concat(encodeURIComponent(targetUrl), "#/login");
      var zljURL = "https://jqh5.zhaoliangji.com/#/login?redirect=".concat(encodeURIComponent(targetUrl));
      var commonURL = "".concat(domain, "/common/loginsms/index.html?headTip=").concat(encodeURIComponent(headTip || ""), "&callbackUrl=").concat(encodeURIComponent(targetUrl), "#/login");
      var redirectMethod = needReplaceLocation ? "replace" : "assign";

      if (!this.isLogin()) {
        // 判断url中是否存在token或PPU，且token的值为PPU
        // 如果存在，则把PPU解析好，放入cookie中，并且执行登录成功的回调
        // 如果不存在，则跳转登录页面
        var ppu = getUrlParamsWithoutDecode()["token"] || getUrlParamsWithoutDecode()["PPU"];
        ppu = decodeURIComponent(ppu);

        if (isCheck) {
          window.location[redirectMethod](checkURL);
        } else if (ppu) {
          // 通过判断token中是否含有UID=字段，来判断token是否为PPU
          if (ppu && ppu.indexOf("UID=") > -1) {
            if (!/^['|"]/.test(ppu)) {
              ppu = "\"".concat(ppu, "\"");
            }

            setCookieOrigin("PPU", ppu);
            setCookieOrigin("ZZU", ppu);
            callback({
              code: "0"
            });
          } else {
            if (isZlj) {
              window.location[redirectMethod](zljURL);
            } else {
              window.location[redirectMethod](commonURL);
            }
          }
        } else {
          window.location[redirectMethod](commonURL);
        }
      } else {
        if (callback) callback({
          code: "0"
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      window.history.go(-1);
    }
  }, {
    key: "enterUnifiedUrl",
    value: function enterUnifiedUrl() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var url = args[0].unifiedUrl;

      var cb = args[1] || function () {};

      if (isHTTPUrl(url)) {
        this.skipToUrl({
          targetUrl: url
        }, cb);
        return;
      }

      if (typeof window.CallApp === "function") {
        var callapp = new CallApp();
        callapp.start({
          path: url
        });
      } else {
        window.location.href = urlFormatter(url);
      }
    }
  }]);

  return MAdapter;
}(BaseAdapter), (_applyDecoratedDescriptor(_class.prototype, "login", [beforeLogin], Object.getOwnPropertyDescriptor(_class.prototype, "login"), _class.prototype)), _class);
export { MAdapter as default };